<template>
	<v-select
		v-model="plan"
		label="סוג תכנית"
		:items="planTypes"
	/>
</template>

<script>

export default {
	name: "PlansSelect",
	props: { value: Number },
	data: function () {
		return {
			planTypes: [
				{
					text: "לפי מספר פעמים",
					value: 1,
				},
				{
					text: "לפי מספר ימים",
					value: 2,
				},
				{
					text: "לפי מספר שעות",
					value: 3,
				},
			],
		};
	},
	computed: {
		plan: {
			get () {
				return this.value;
			},
			set (val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		updatePlan () {
			this.$emit("selected-plan", this.selectedPlan);
		},
	},
};
</script>
